import CssBaseline from '@mui/material/CssBaseline';
import LoginContainer from 'components/login/LoginContainer';
import SignUpForm from 'components/signup/SignUpForm';

function SignUpPage(): JSX.Element {
  return (
    <>
      <CssBaseline />
      <LoginContainer value="Sign Up" component={<SignUpForm />} />
    </>
  );
}

export default SignUpPage;
